<app-header></app-header>
<div class="container-fluid">
  <div class="row">
    <div class="col-md-1 col-lg-1 col-xl-1" id="rt_leftside-content">
      <app-side-bar></app-side-bar>
    </div>
    <div class="col-md-11 col-lg-11 col-xl-11" id="rt_rightside-content">
      <div class="content d-flex flex-column flex-column-fluid" id="rt_content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

